import { useEffect, useState } from 'react';

// SVG frames for the loading animation
const Frame0 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1107 9.44531V11.6579C13.1107 12.4404 12.4748 13.075 11.6903 13.075H0.391371C0.0434831 13.075 -0.130898 12.6553 0.115159 12.4099L2.76365 9.76875C2.97125 9.5617 3.25315 9.44531 3.54684 9.44531H13.1116H13.1107Z"
      fill="#90959D"
    />
    <path
      d="M13.1099 4.45312V6.66532C13.1099 7.44775 12.474 8.08242 11.689 8.08242H4.45898L7.77397 4.77656C7.98157 4.56951 8.26303 4.45312 8.55672 4.45312H13.1103H13.1099Z"
      fill="#90959D"
    />
    <path
      d="M13.1104 0.390345V1.66274C13.1104 2.44518 12.4745 3.07985 11.6896 3.07985H9.4707L12.4435 0.114857C12.6895 -0.130555 13.1104 0.043369 13.1104 0.390345Z"
      fill="#90959D"
    />
  </svg>
);

const Frame1 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1107 9.44531V11.6579C13.1107 12.4404 12.4748 13.075 11.6903 13.075H0.391371C0.0434831 13.075 -0.130898 12.6553 0.115159 12.4099L2.76365 9.76875C2.97125 9.5617 3.25315 9.44531 3.54684 9.44531H13.1116H13.1107Z"
      fill="black"
    />
    <path
      d="M13.1099 4.45312V6.66532C13.1099 7.44775 12.474 8.08242 11.689 8.08242H4.45898L7.77397 4.77656C7.98157 4.56951 8.26303 4.45312 8.55672 4.45312H13.1103H13.1099Z"
      fill="#90959D"
    />
    <path
      d="M13.1104 0.390345V1.66274C13.1104 2.44518 12.4745 3.07985 11.6896 3.07985H9.4707L12.4435 0.114857C12.6895 -0.130555 13.1104 0.043369 13.1104 0.390345Z"
      fill="#90959D"
    />
  </svg>
);

const Frame2 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1107 9.44531V11.6579C13.1107 12.4404 12.4748 13.075 11.6903 13.075H0.391371C0.0434831 13.075 -0.130898 12.6553 0.115159 12.4099L2.76365 9.76875C2.97125 9.5617 3.25315 9.44531 3.54684 9.44531H13.1116H13.1107Z"
      fill="black"
    />
    <path
      d="M13.1099 4.45312V6.66532C13.1099 7.44775 12.474 8.08242 11.689 8.08242H4.45898L7.77397 4.77656C7.98157 4.56951 8.26303 4.45312 8.55672 4.45312H13.1103H13.1099Z"
      fill="black"
    />
    <path
      d="M13.1104 0.390345V1.66274C13.1104 2.44518 12.4745 3.07985 11.6896 3.07985H9.4707L12.4435 0.114857C12.6895 -0.130555 13.1104 0.043369 13.1104 0.390345Z"
      fill="#90959D"
    />
  </svg>
);

const Frame3 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1107 9.44531V11.6579C13.1107 12.4404 12.4748 13.075 11.6903 13.075H0.391371C0.0434831 13.075 -0.130898 12.6553 0.115159 12.4099L2.76365 9.76875C2.97125 9.5617 3.25315 9.44531 3.54684 9.44531H13.1116H13.1107Z"
      fill="black"
    />
    <path
      d="M13.1099 4.45312V6.66532C13.1099 7.44775 12.474 8.08242 11.689 8.08242H4.45898L7.77397 4.77656C7.98157 4.56951 8.26303 4.45312 8.55672 4.45312H13.1103H13.1099Z"
      fill="black"
    />
    <path
      d="M13.1104 0.390345V1.66274C13.1104 2.44518 12.4745 3.07985 11.6896 3.07985H9.4707L12.4435 0.114857C12.6895 -0.130555 13.1104 0.043369 13.1104 0.390345Z"
      fill="black"
    />
  </svg>
);

const frames = [Frame0, Frame1, Frame2, Frame3];

interface AIAssistantLoadingIndicatorProps {
  className?: string;
  animate?: boolean;
}

export const AIAssistantLoadingIndicator = ({
  className = '',
  animate = true,
}: AIAssistantLoadingIndicatorProps) => {
  const [currentFrame, setCurrentFrame] = useState(0);

  useEffect(() => {
    if (!animate) {
      // Stop animation on the final frame when canceled
      setCurrentFrame(frames.length - 1);
      return;
    }

    const interval = setInterval(() => {
      setCurrentFrame((prev) => (prev + 1) % frames.length);
    }, 400); // Change frame every 400ms

    return () => clearInterval(interval);
  }, [animate]);

  const CurrentFrameComponent = frames[currentFrame];

  return (
    <div className={`inline-flex items-center ${className}`}>
      <CurrentFrameComponent />
    </div>
  );
};
